/* tslint:disable */
/* eslint-disable */
/**
 * pinnacle-backend API spec
 * Backend Service for Pinnacle Underwriting | [swagger.json](pinnacle/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SubLimitSettingResponseDto
 */
export interface SubLimitSettingResponseDto {
    /**
     * 
     * @type {string}
     * @memberof SubLimitSettingResponseDto
     */
    subLimitSettingId: string;
    /**
     * 
     * @type {string}
     * @memberof SubLimitSettingResponseDto
     */
    layerId: string;
    /**
     * 
     * @type {number}
     * @memberof SubLimitSettingResponseDto
     */
    layerNumber: number;
    /**
     * 
     * @type {boolean}
     * @memberof SubLimitSettingResponseDto
     */
    fire: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SubLimitSettingResponseDto
     */
    wind: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SubLimitSettingResponseDto
     */
    earthquake: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SubLimitSettingResponseDto
     */
    flood: boolean;
}

/**
 * Check if a given object implements the SubLimitSettingResponseDto interface.
 */
export function instanceOfSubLimitSettingResponseDto(value: object): value is SubLimitSettingResponseDto {
    if (!('subLimitSettingId' in value) || value['subLimitSettingId'] === undefined) return false;
    if (!('layerId' in value) || value['layerId'] === undefined) return false;
    if (!('layerNumber' in value) || value['layerNumber'] === undefined) return false;
    if (!('fire' in value) || value['fire'] === undefined) return false;
    if (!('wind' in value) || value['wind'] === undefined) return false;
    if (!('earthquake' in value) || value['earthquake'] === undefined) return false;
    if (!('flood' in value) || value['flood'] === undefined) return false;
    return true;
}

export function SubLimitSettingResponseDtoFromJSON(json: any): SubLimitSettingResponseDto {
    return SubLimitSettingResponseDtoFromJSONTyped(json, false);
}

export function SubLimitSettingResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): SubLimitSettingResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'subLimitSettingId': json['subLimitSettingId'],
        'layerId': json['layerId'],
        'layerNumber': json['layerNumber'],
        'fire': json['fire'],
        'wind': json['wind'],
        'earthquake': json['earthquake'],
        'flood': json['flood'],
    };
}

export function SubLimitSettingResponseDtoToJSON(json: any): SubLimitSettingResponseDto {
    return SubLimitSettingResponseDtoToJSONTyped(json, false);
}

export function SubLimitSettingResponseDtoToJSONTyped(value?: SubLimitSettingResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'subLimitSettingId': value['subLimitSettingId'],
        'layerId': value['layerId'],
        'layerNumber': value['layerNumber'],
        'fire': value['fire'],
        'wind': value['wind'],
        'earthquake': value['earthquake'],
        'flood': value['flood'],
    };
}

